import './index.css';

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Pagination } from 'semantic-ui-react';

import { SearchActionButtonSection } from '../../search/actionSection';
import SearchTable from '../../search/search-table.js';

@withRouter
class PublishedTable extends Component {
  state = {
    page: 1,
    itemsPerPage: 10
  };

  setPageNum = (event, { activePage }) => {
    this.setState({ page: activePage });
  };

  getTableModel = () => {
    function actionSection(actions) {
      return [
        {
          icon: 'edit',
          label: 'Edit',
          action: actions.load
        },
        {
          icon: 'history',
          label: 'History',
          action: actions.history
        }
      ];
    }
    return [
      {
        label: 'Title',
        property: 'info.schemaName',
        type: 'string'
      },
      {
        label: 'Actions',
        type: 'component',
        component: SearchActionButtonSection,
        model: actionSection
      }
    ];
  };
  getActions = () => {
    const { history } = this.props;
    return {
      load: (item) => {
        if (item._id) {
          history.push(`/schema-editor/${item._id}/edit-info`);
        }
      },
      history: (item) => {
        history.push(`/schema/history/${item._id}`);
      }
    };
  };
  render() {
    const itemsPerPage = 10;
    const { page } = this.state;
    const totalPages = Math.round(this.props.items.length / itemsPerPage);
    const items = this.props.items.slice(
      (page - 1) * itemsPerPage,
      (page - 1) * itemsPerPage + itemsPerPage
    );
    return (
      <div className={'dashboard-tile-frame'}>
        <div className="schema-tile schema-table-frame">
          <div className="schema-table">
            <SearchTable
              items={items}
              actions={this.getActions()}
              model={this.getTableModel()}
              basic={'very'}
              compact={true}
            />
            <Pagination
              floated="right"
              activePage={page}
              totalPages={totalPages}
              siblingRange={1}
              onPageChange={this.setPageNum}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default PublishedTable;
